import React, { createContext, useState, useEffect, useContext } from 'react';
import { onAuthStateChange } from '../firebase/auth';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isStaff, setIsStaff] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (user) => {
      if (user) {
        const tokenResult = await user.getIdTokenResult();
        const isStaffUser = tokenResult.claims.role === 'staff';
        setIsStaff(isStaffUser);
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
        setIsStaff(false);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    loading,
    isAuthenticated: !!currentUser,
    isStaff
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};